module.exports = __webpack_public_path__ + "static/media/jar-middle.883fb871.png";